import React, { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import MyNexarContext from "../../../../components/my-nexar-context/my-nexar-context";
import ErrorBox from "../../../../components/error-box/error-box";
import { Subscription } from "../../../../contracts/nexar-api/types";
import styles from "./my-subscriptions.module.scss";
import SubscriptionCard from "../subscription-card/subscription-card";
import toast from "react-hot-toast";
interface Props {
  subscriptions: Subscription[] | null;
}

export function MySubscriptions(props: Props) {
  const { subscriptions } = props;
  const { t } = useTranslation();
  const context = useContext(MyNexarContext);
  const isInApp = !!sessionStorage.getItem('app')

  // Clear the subscription error when unmounting this component
  useEffect(() => {
    return () => context.clearSubscriptionMessage();
  }, []);

  const placeholderSubscription = <SubscriptionCard subscription={undefined} />;

  useEffect(() => {
    if (context.subscriptions.status === "success") {
      toast.success(t(context.subscriptions.successMessage));
      return () => {
        toast.dismiss();
      };
    }
  }, [context.subscriptions.status]);

  useEffect(() => {
    if (context.subscriptions.status === "error") {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [context.subscriptions.status]);

  return (
    <div className={styles.MySubscriptionWrapper}>
      {context.subscriptions.status === "error" && (
        <ErrorBox
          message={t(context.subscriptions.errorMessage)}
          docUrl={context.subscriptions.errorDocUrl}
        />
      )}
      <h1 data-testid={"my-subscriptions-title"}>{t("nexarConnect")}</h1>
      <p>{isInApp ? t("mySubscriptionInstructionsError"): t("mySubscriptionInstructions")} </p>
      <div className={styles.ListWrapper}>
        {subscriptions
          ? subscriptions.map((item) => (
              <SubscriptionCard key={item.subscriptionId} subscription={item} />
            ))
          : placeholderSubscription}
      </div>
    </div>
  );
}

export default MySubscriptions;
